export default {

  merchants: state => state.merchants,
  currentMerchant: state => state.currentMerchant,
  activityGroups: state => state.activityGroups,
  currentActivityGroup: state => state.currentActivityGroup,
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  isCalling: state => state.isCalling
}
